<template>
    <section class="quote" :class="`quote--${variant}`">
        <div class="wrapper">
            <div class="quote__quote" v-html="quote"></div>
            <div class="quote__attribution" v-html="`- ${attribution}`"></div>
        </div>
    </section>
</template>

<script>
export default {
    props: {
        quote: {
            type: String,
            default: "Lorem Ipsum",
        },
        attribution: {
            type: String,
            default: "John Doe",
        },
        variant: {
            type: String,
            default: "primary",
        },
    },
}
</script>

<style lang="scss" scoped>
.quote {
    padding: 9rem 0;
    text-align: right;
    color: var(--secondary_colour);
    background-color: var(--primary_colour);

    @include mobile {
        padding: 4rem 0;
    }

    &__quote {
        font-size: 5rem;
        line-height: 1.11;
        font-family: var(--title_font);
        padding-left: 10rem;

        @include tablet-and-mobile {
            padding-left: 0;
            font-size: 4rem;
        }

        @include mobile {
            font-size: 1.5rem;
        }
    }
    &__attribution {
        font-size: 1.5rem;
        margin-top: 1rem;
        @include mobile {
            font-size: 1rem;
            margin-top: 0.5rem;
        }
    }
}

.quote--secondary {
    background-color: var(--secondary_colour);
    color: var(--primary_colour);
}
</style>
